// extracted by mini-css-extract-plugin
module.exports = {"topright":"examenes_topright_2b2fm","titulo":"examenes_titulo_QQLNd"};